function ApplicationForm() {
  return (
    <div className="p-8">
      <h1 className="text-3xl font-bold text-brand mb-4">ApplicationForm</h1>
      <p className="text-ink/70">This is the ApplicationForm page. Content coming soon.</p>
    </div>
  );
}

export default ApplicationForm;
